
import React, {  } from 'react';
import useGlobal from '../../store';
import KeyElementWidget from '../Dashboard/KeyElementWidget';
import CurrencySymbol from '../General/CurrencySymbol';
import ActivityFeed from '../General/ActivityFeed';

const Home = (props) => {

    const [giftlists] = useGlobal(
        state => state.giftlists
    );
    const [mygiftlistCount] = useGlobal(
        state => state.mygiftlist.length
    );
    const [shoppinglist] = useGlobal(
        state => state.shoppinglist
    );


    const totalBudget = giftlists.reduce((tot, gl) => tot + (gl.budget * 1), 0).toFixed(0);
    const totalSpent = giftlists.reduce((tot, gl) => tot + (gl.spent * 1), 0).toFixed(0);

    const shoppingBoxDescription = <>
        Claim gifts, prevent duplicates, and track your shopping progress.
        <div>
            <div className="badge badge-primary m-2">Budget: <CurrencySymbol></CurrencySymbol>{totalBudget}</div>
            <div className="badge badge-success m-2">Spent: <CurrencySymbol></CurrencySymbol>{totalSpent}</div>
        </div>
    </>;

    return (<>
        <div className="row">
            <div className="col-md-4 col-lg-4 order-md-1 order-lg-1">
                <KeyElementWidget title="Gift Lists" subtitle="" description="Add gift lists for everyone on your 'Nice List'. Share them with family & friends." number={giftlists.length} viewpanel="nicelist" addpanel="addgiftlist"></KeyElementWidget>
            </div>
            <div className="col-md-4 col-lg-4 order-md-1 order-lg-1">
                <KeyElementWidget title="Shopping List" subtitle="" description={shoppingBoxDescription} number={shoppinglist.length} color="warning" viewpanel="shoppinglist"></KeyElementWidget>
            </div>
            <div className="col-md-4 col-lg-4 order-md-1 order-lg-1">
                <KeyElementWidget title="Your Gift List" subtitle="" description="Help others find you the perfect gift! Add items from any store." number={mygiftlistCount} color="info" addpanel="additem" ></KeyElementWidget>
            </div>
        </div>	
        <div className="row">
            <div className="col-md-6">
                <ActivityFeed></ActivityFeed>
            </div>
        </div>
    </>);
}
export default Home;